/**
 * WizardNavigation Component
 * Shared back/next navigation for wizards
 */

import React from 'react';
import { Button } from 'antd';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';
import './WizardShared.scss';

interface WizardNavigationProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onNext: () => void;
  onComplete?: () => void;
  nextLabel?: string;
  completeLabel?: string;
  canProceed?: boolean;
  isLoading?: boolean;
}

export const WizardNavigation: React.FC<WizardNavigationProps> = ({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  onComplete,
  nextLabel = 'Next',
  completeLabel = 'Create Project',
  canProceed = true,
  isLoading = false
}) => {
  const isLastStep = currentStep === totalSteps;

  return (
    <div className="wizard-navigation">
      <Button 
        onClick={onBack} 
        disabled={currentStep === 1 || isLoading}
        className="wizard-nav-btn back"
        icon={<ArrowLeft size={16} />}
      >
        Back
      </Button>
      
      {isLastStep ? (
        <Button 
          type="primary"
          onClick={onComplete}
          disabled={!canProceed}
          loading={isLoading}
          className="wizard-nav-btn complete"
          icon={<Check size={16} />}
        >
          {completeLabel}
        </Button>
      ) : (
        <Button 
          type="primary"
          onClick={onNext}
          disabled={!canProceed || isLoading}
          loading={isLoading}
          className="wizard-nav-btn next"
        >
          {nextLabel}
          <ArrowRight size={16} />
        </Button>
      )}
    </div>
  );
};

export default WizardNavigation;
